/*
 * @Author: your name
 * @Date: 2021-06-24 18:59:36
 * @LastEditTime: 2021-06-25 11:59:49
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \platform_web_ai_admin\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import {
  getUserRole
} from "@/api/user";
import {
  getMenuList,
  permissionListToPermissions
} from "@/lib/permissionFunc";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: localStorage.getItem("USER_NAME") || '',
    menuList: [], //菜单列表
    permissionList: [], //权限列表
    pagePermissionList: [], //当前页面权限操作列表
    userImg: localStorage.getItem("adminAvatar"),
    showBrowserTip: sessionStorage.AGENT_TIP ? JSON.parse(sessionStorage.AGENT_TIP) : true,
  },
  mutations: {
    setBrowserTip(state = this.state, flag) {
      state.showBrowserTip = flag;
      sessionStorage.setItem("AGENT_TIP", flag);
      return state.showBrowserTip;
    },
    setUsername(state = this.state, name) {
      state.username = name;
      return state.username;
    },
    setMenuList(state = this.state, list) {
      state.menuList = list;
    },
    setPermission(state = this.state, list) {
      state.permissionList = list;
    },
    setPagePermission(state = this.state, list) {
      state.pagePermissionList = list;
    },
    setUserImg(state = this.state, name) {
      state.userImg = name;
      return state.userImg;
    },
  },
  actions: {
    //获取权限和菜单
    getRole({
      commit
    }) {
      return new Promise((resolve, reject) => {
        getUserRole().then((res) => {
          console.log(res, "权限列表");
          // return;
          if (res.data.code == 0) {
            // 无权限
            if (!res.data.data) {
              resolve(false);
              return;
            }
            //权限用
            let permissionList = JSON.parse(JSON.stringify(res.data.data));
            commit('setPermission', permissionList);
            //菜单用
            let list = JSON.parse(JSON.stringify(res.data.data));
            //当前页面权限用
            let arr = JSON.parse(JSON.stringify(res.data.data));
            //获取菜单
            let menuList = getMenuList(list);
            if (localStorage.IS_ACCESS_INDUSTRY == 1) {
              menuList = menuList.filter(x => x.frontendCode == 'quota' || x.frontendCode == 'service');
            }
            commit('setMenuList', menuList);
            //获取权限,以及页面的操作权限
            let pagePermissionList = permissionListToPermissions(arr);
            commit('setPagePermission', pagePermissionList);
            let obj = {
              pagePermissionList: pagePermissionList,
              menuList: menuList,
              permissionList: permissionList
            };
            console.log(obj, "当前角色信息");
            resolve(obj)
          } else {
            console.log('获取权限失败');
            reject(res.data.msg);
          }
        }).catch(err => {
          console.log(err, "err--");
          reject(err);
        });
      })
    },
  },
  modules: {}
})